import { lazy } from "react";

const AllTransactions = lazy(() => import("../../../pages/User/transactions/AllTransactions"));
// const Transaction = lazy(()=>import("../../../pages/User/transactions/Transactions"))
export const transactionRoutes = [
  { path: "transactions/:cat", element: <AllTransactions /> },
];
